export const stringReplaceAll = (target: string, search: string, replacement: string): string =>
  target.replace(new RegExp(search, 'g'), replacement)

export const escapeHtml = (s: string | null | undefined): string =>
  s == null ? '' : String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')

const stringReverse = (string: string): string => string.split('').reverse().join('')

export const stringReplaceLast = (target: string, what: string, replacement: string): string =>
  stringReverse(stringReverse(target).replace(new RegExp(stringReverse(what)), stringReverse(replacement)))
